import { useCallback, useState } from "react"
import { centsClient } from "../../../api/cents/clients/cents-client"
import { RecurrenceInterval } from "../../../types/recurring-interval"

interface SubscriptionChangeHook {
  save: (value: {
    stripeSetupIntentId?: string
    recurrence?: RecurrenceInterval
    recurrenceCount?: number
    selectedDonationAmount?: number
    delete?: boolean
  }) => Promise<void>
  clearError: () => void
  error: 'save_error' | undefined
  state: 'idle' | 'loading' | 'success'
}
export function useSubscriptionChange(charityId: string, contractId: string): SubscriptionChangeHook {
  const [error, setError] = useState<'save_error'>()
  const [state, setState] = useState<'idle' | 'loading' | 'success'>('idle')

  const clearError = useCallback(() => {
    setError(undefined)
  }, [])

  const save = useCallback(async (value: {
    stripeSetupIntentId?: string
    recurrence?: RecurrenceInterval
    selectedDonationAmount?: number
    delete?: boolean
  }) => {
    setState('loading')
    try {
      await centsClient.contracts.updateSubscription(charityId, contractId, value)
    } catch {
      setError("save_error")
      return
    } finally {
      setState('idle')
    }
    setState('success')
  }, [charityId, contractId])

  return { save, clearError, error, state }
}